<template>
    <div>
        <v-main>
            <wzvz_overview_all :filter="filter"/>
        </v-main>
        <navBar title="Ares - Main menu" :home="true" type="main" />
    </div>
</template>

<script>
    import navBar from "@/components/ui/navbars/navbar.vue";

    import wzvz_overview_all from '@/components/wzvz/wzvz_overview_all.vue'

    export default {
        components: {
            navBar,
            wzvz_overview_all,
        }, 
        props: {
            filter: {
                type: String,
                required: true
            }
        },    
        data() {
            return {
            }
        },    
        methods: {     
        }
    }
</script>

<style scoped> 

</style>